module.exports = __webpack_public_path__ + "static/urchin_mtg_clb-db64e4de0157458ac6540b68992c2567.webp";